// GERADO por scripts/gerar-nbs-incidencia.py em 2026-09-11 — não edite à mão.
// Fonte: Anexo VIII (Correlação Item NBS × IndOp × cClassTrib) da NFS-e Nacional.
//
// Para cada NBS (9 dígitos, sem pontos): [cIndOp, local de incidência, item LC 116].
// O local é o lugar onde a operação é considerada realizada para o IBS/CBS
// (LC 214/2025, art. 11). Códigos em LOCAL_INCIDENCIA.

export const LOCAL_INCIDENCIA = {
  "A": "Domicílio principal do adquirente",
  "P": "Local da prestação",
  "I": "Local do imóvel",
  "E": "Local da entrega ou da disponibilização",
  "V": "Local do evento",
  "X": "Via explorada"
};

export const NBS_INCIDENCIA = {
  "101011100": ["020201", "I", "07.05"],
  "101011200": ["020201", "I", "07.05"],
  "101012100": ["020201", "I", "07.05"],
  "101012200": ["020201", "I", "07.05"],
  "101012900": ["020201", "I", "07.05"],
  "101013000": ["020201", "I", "07.05"],
  "101021100": ["020201", "I", "07.05"],
  "101021200": ["020201", "I", "07.05"],
  "101021300": ["020201", "I", "07.05"],
  "101022000": ["020201", "I", "07.05"],
  "101023100": ["020201", "I", "07.05"],
  "101023200": ["020201", "I", "07.05"],
  "101023300": ["020201", "I", "07.05"],
  "101023400": ["020201", "I", "07.05"],
  "101023510": ["020201", "I", "07.05"],
  "101023520": ["020201", "I", "07.05"],
  "101023530": ["020201", "I", "07.05"],
  "101024110": ["020201", "I", "07.05"],
  "101024120": ["020201", "I", "07.05"],
  "101024190": ["020201", "I", "07.05"],
  "101024210": ["020201", "I", "07.05"],
  "101024220": ["020201", "I", "07.05"],
  "101025100": ["020201", "I", "07.05"],
  "101025210": ["020201", "I", "07.05"],
  "101025220": ["020201", "I", "07.05"],
  "101025310": ["020201", "I", "07.05"],
  "101025320": ["020201", "I", "07.05"],
  "101026100": ["020201", "I", "07.05"],
  "101026900": ["020201", "I", "07.05"],
  "101027000": ["020201", "I", "07.05"],
  "101028000": ["020201", "I", "07.05"],
  "101029000": ["020201", "I", "07.05"],
  "101031000": ["020201", "I", "07.04"],
  "101032000": ["020201", "I", "07.02"],
  "101033000": ["020201", "I", "07.02"],
  "101034100": ["020201", "I", "07.02"],
  "101034200": ["020201", "I", "07.02"],
  "101040000": ["020201", "I", "07.02"],
  "101051100": ["020201", "I", "07.17"],
  "101051200": ["020201", "I", "07.02"],
  "101052100": ["020201", "I", "07.02"],
  "101052200": ["020201", "I", "07.02"],
  "101053000": ["020201", "I", "07.02"],
  "101054000": ["020201", "I", "07.02"],
  "101055000": ["020201", "I", "07.02"],
  "101056000": ["020201", "I", "07.02"],
  "101057000": ["050101", "P", "03.05"],
  "101059000": ["020201", "I", "07.02"],
  "101061100": ["020201", "I", "07.02"],
  "101061200": ["050101", "P", "14.06"],
  "101061300": ["050101", null, "14.06"],
  "101061400": ["050101", null, "14.06"],
  "101061900": ["050101", null, "14.06"],
  "101062100": ["020201", "I", "07.02"],
  "101062200": ["020201", "I", "07.02"],
  "101063100": ["050101", null, "14.06"],
  "101063200": ["050101", null, "14.06"],
  "101064000": ["050101", null, "14.06"],
  "101065000": ["020201", "I", "07.06"],
  "101066000": ["050101", null, "14.06"],
  "101069000": ["050101", null, "14.06"],
  "101071000": ["020201", "I", "07.06"],
  "101072000": ["020201", "I", "07.06"],
  "101073000": ["020201", "I", "07.05"],
  "101074000": ["020201", "I", "07.07"],
  "101075000": ["050101", "P", "14.13"],
  "101076000": ["050101", null, "14.06"],
  "101079000": ["020201", "I", "07.08"],
  "102010000": ["100301", "A", "10.10"],
  "102040000": ["100301", "A", "33.01"],
  "102050000": ["100301", "A", "10.05"],
  "103011000": ["030101", "P", "17.11"],
  "103013100": ["030101", null, "17.11"],
  "103013900": ["030101", null, "17.11"],
  "103031100": ["030101", "P", "09.01"],
  "103031200": ["030101", "P", "09.01"],
  "103031300": ["030101", "P", "09.01"],
  "103031400": ["030101", "P", "09.01"],
  "103032000": ["030101", "P", "09.01"],
  "103039000": ["030101", "P", "09.01"],
  "103041000": ["030101", "P", "09.01"],
  "103042000": ["030101", "P", "09.01"],
  "103049000": ["030101", "P", "09.01"],
  "104011111": ["060101", "P", "16.02"],
  "104011119": ["060101", "P", "16.01"],
  "104011210": ["060101", "P", "16.02"],
  "104011220": ["060101", "P", "16.02"],
  "104011290": ["060101", "P", "16.02"],
  "104011300": ["060101", "P", "16.02"],
  "104011400": ["060101", "P", "16.02"],
  "104011510": ["060101", "P", "16.02"],
  "104011520": ["060101", "P", "16.02"],
  "104011610": ["060101", "P", "16.01"],
  "104011620": ["060101", "P", "16.01"],
  "104011690": ["060101", "P", "16.01"],
  "104011710": ["100301", "A", "09.02"],
  "104011720": ["100301", "A", "09.02"],
  "104011790": ["100301", "A", "09.02"],
  "104011900": ["060101", "P", "16.02"],
  "104012110": ["060101", "P", "16.01"],
  "104012120": ["050201", "P", "20.01"],
  "104012190": ["060101", "P", "16.02"],
  "104012200": ["060101", "P", "16.02"],
  "104012300": ["100301", "A", "09.02"],
  "104012900": ["060101", "P", "16.02"],
  "104013000": ["060101", "P", "16.01"],
  "104014100": ["060101", "P", "16.02"],
  "104014200": ["060101", "P", "16.02"],
  "104014300": ["100301", "A", "09.02"],
  "104014900": ["060101", "P", "16.02"],
  "104019000": ["060101", "P", "16.02"],
  "104021320": ["100301", "A", "09.02"],
  "104041000": ["060101", "P", "16.02"],
  "104042000": ["060101", "P", "16.02"],
  "104043000": ["060101", "P", "16.02"],
  "104050000": ["060101", "P", "16.02"],
  "105011110": ["070101", "P", "16.02"],
  "105011120": ["070101", "P", "16.02"],
  "105011130": ["070101", "P", "16.02"],
  "105011210": ["070101", "P", "16.02"],
  "105011220": ["070101", "P", "16.02"],
  "105011230": ["070101", "P", "16.02"],
  "105011310": ["070101", "P", "16.02"],
  "105011320": ["070101", "P", "16.02"],
  "105011410": ["070101", "P", "16.02"],
  "105011420": ["070101", "P", "16.02"],
  "105011430": ["070101", "P", "16.02"],
  "105011440": ["070101", "P", "16.02"],
  "105011451": ["070101", "P", "16.02"],
  "105011452": ["070101", "P", "16.02"],
  "105011459": ["070101", "P", "16.02"],
  "105011500": ["070101", "P", "26.01"],
  "105011900": ["070101", "P", "16.02"],
  "105013100": ["070101", "P", "16.02"],
  "105021110": ["070101", "P", "16.02"],
  "105021120": ["070101", "P", "16.02"],
  "105021130": ["070101", "P", "16.02"],
  "105021210": ["070101", "P", "16.02"],
  "105021220": ["070101", "P", "16.02"],
  "105021230": ["070101", "P", "16.02"],
  "105021310": ["070101", "P", "16.02"],
  "105021320": ["070101", "P", "16.02"],
  "105021410": ["070101", "P", "16.02"],
  "105021420": ["070101", "P", "16.02"],
  "105021430": ["070101", "P", "16.02"],
  "105021440": ["070101", "P", "16.02"],
  "105021451": ["070101", "P", "16.02"],
  "105021452": ["070101", "P", "16.02"],
  "105021459": ["070101", "P", "16.02"],
  "105021490": ["070101", "P", "16.02"],
  "105021900": ["070101", "P", "16.02"],
  "105022110": ["070101", "P", "16.02"],
  "105022120": ["070101", "P", "16.02"],
  "105022130": ["070101", "P", "16.02"],
  "105022210": ["070101", "P", "16.02"],
  "105022220": ["070101", "P", "16.02"],
  "105022230": ["070101", "P", "16.02"],
  "105022310": ["070101", "P", "16.02"],
  "105022320": ["070101", "P", "16.02"],
  "105022410": ["070101", "P", "16.02"],
  "105022420": ["070101", "P", "16.02"],
  "105022430": ["070101", "P", "16.02"],
  "105022440": ["070101", "P", "16.02"],
  "105022451": ["070101", "P", "16.02"],
  "105022452": ["070101", "P", "16.02"],
  "105022459": ["070101", "P", "16.02"],
  "105022900": ["070101", "P", "16.02"],
  "105051000": ["070101", "P", "16.02"],
  "105052000": ["070101", "P", "16.02"],
  "105053000": ["070101", "P", "16.02"],
  "106011000": ["050201", "P", "20.01"],
  "106019000": ["050101", "P", "20.03"],
  "106021000": ["050201", "P", "20.01"],
  "106022100": ["050201", "P", "20.01"],
  "106022200": ["050201", "P", "20.01"],
  "106022300": ["050201", "P", "20.01"],
  "106022900": ["050201", "P", "20.01"],
  "106023100": ["050201", "P", "20.01"],
  "106023200": ["050201", "P", "20.01"],
  "106023300": ["050201", "P", "20.01"],
  "106029000": ["050101", "P", "20.02"],
  "106030000": ["100301", "A", "20.03"],
  "106041000": ["100301", "A", "20.03"],
  "106042100": ["080101", "X", "22.01"],
  "106042200": ["080101", "X", "22.01"],
  "106043000": ["050101", "P", "11.01"],
  "106044000": ["050101", "P", "14.14"],
  "106049000": ["100301", "A", "20.03"],
  "106051000": ["050201", "P", "20.01"],
  "106052000": ["050201", "P", "20.01"],
  "106053000": ["050201", "P", "20.01"],
  "106054000": ["050201", "P", "20.01"],
  "106059000": ["050201", "P", "20.01"],
  "106061100": ["100301", "A", "20.02"],
  "106061200": ["100301", "A", "20.02"],
  "106061900": ["100301", "A", "20.02"],
  "106062000": ["100301", "A", "20.02"],
  "106070000": ["100301", "A", "10.06"],
  "106081000": ["070101", "P", "26.01"],
  "106082000": ["050101", null, "11.04"],
  "106083000": ["050101", null, "11.04"],
  "106084000": ["100301", "A", "17.01"],
  "107010000": ["070101", "P", "26.01"],
  "107020000": ["070101", "P", "26.01"],
  "107030000": ["070101", "P", "26.01"],
  "109012100": ["100301", "A", "15.15"],
  "109012200": ["100301", "A", "15.15"],
  "109012900": ["100301", "A", "15.15"],
  "109013100": ["100301", "A", "15.18"],
  "109013200": ["100301", "A", "15.18"],
  "109013300": ["100301", "A", "15.08"],
  "109013400": ["100301", "A", "15.08"],
  "109013500": ["100301", "A", "15.08"],
  "109013600": ["100301", "A", "15.08"],
  "109013900": ["100301", "A", "15.08"],
  "109014000": ["100301", "A", "15.14"],
  "109015111": ["100301", "A", "15.09"],
  "109015112": ["100301", "A", "15.09"],
  "109015113": ["100301", "A", "15.09"],
  "109015114": ["100301", "A", "15.09"],
  "109015115": ["100301", "A", "15.09"],
  "109015116": ["100301", "A", "15.09"],
  "109015117": ["100301", "A", "15.09"],
  "109015121": ["100301", "A", "15.09"],
  "109015122": ["100301", "A", "15.09"],
  "109015123": ["100301", "A", "15.09"],
  "109015124": ["100301", "A", "15.09"],
  "109015125": ["100301", "A", "15.09"],
  "109015129": ["100301", "A", "15.09"],
  "109015210": ["100301", "A", "15.09"],
  "109015220": ["100301", "A", "15.09"],
  "109015230": ["100301", "A", "15.09"],
  "109015240": ["100301", "A", "15.09"],
  "109015250": ["100301", "A", "15.09"],
  "109015290": ["100301", "A", "15.09"],
  "109019000": ["100301", "A", "15.17"],
  "109021000": ["100301", "A", "28.01"],
  "109051100": ["100301", "A", "19.01"],
  "109051200": ["100301", "A", "10.05"],
  "109051300": ["100301", "A", "15.15"],
  "109052100": ["100301", "A", "15.01"],
  "109052200": ["100301", "A", "15.01"],
  "109052300": ["100301", "A", "15.01"],
  "109053000": ["100301", "A", "15.12"],
  "109054000": ["100301", "A", "15.01"],
  "109055000": ["100301", "A", "17.20"],
  "109056000": ["100301", "A", "15.13"],
  "109057000": ["100301", "A", "17.20"],
  "109058000": ["100301", "A", "17.20"],
  "109059000": ["100301", "A", "10.04"],
  "109061100": ["100301", "A", "10.01"],
  "109061200": ["100301", "A", "10.01"],
  "109062000": ["100301", "A", "18.01"],
  "109063000": ["100301", "A", "17.18"],
  "109064000": ["100301", "A", "15.01"],
  "109080000": ["100301", "A", "17.23"],
  "109101000": ["100301", "A", "04.23"],
  "109102000": ["100301", "A", "10.01"],
  "109109000": ["100301", "A", "04.23"],
  "110011100": ["020301", "I", "17.12"],
  "110011210": ["020201", "I", "03.04"],
  "110011290": ["020301", "I", "17.12"],
  "110012100": ["020301", "I", "10.05"],
  "110012200": ["020301", "I", "10.05"],
  "110013000": ["100301", "A", "28.01"],
  "110014000": ["100301", "A", "17.01"],
  "110015000": ["100301", "A", "17.01"],
  "110019000": ["100301", "A", "17.01"],
  "110021000": ["020201", "I", "99.03.01"],
  "110022000": ["020201", "I", "99.03.01"],
  "111011100": ["010101", "E", "99.04.01"],
  "111011200": ["010101", "E", "99.04.01"],
  "111011300": ["010101", "E", "99.04.01"],
  "111011400": ["010101", "E", "99.04.01"],
  "111011500": ["010101", "E", "99.04.01"],
  "111011600": ["010101", "E", "99.04.01"],
  "111011700": ["010101", "E", "99.04.01"],
  "111012000": ["010101", "E", "99.04.01"],
  "111013000": ["010101", "E", "99.04.01"],
  "111014000": ["010101", "E", "99.04.01"],
  "111015000": ["010101", "E", "99.04.01"],
  "111016000": ["010101", "E", "99.04.01"],
  "111019000": ["010101", "E", "99.04.01"],
  "111021000": ["010101", "E", "99.04.01"],
  "111022000": ["010101", "E", "99.04.01"],
  "111023000": ["010101", "E", "99.04.01"],
  "111024000": ["010101", "E", "99.04.01"],
  "111025000": ["010101", "E", "99.04.01"],
  "111026000": ["010101", "E", "99.04.01"],
  "111029000": ["010101", "E", "99.04.01"],
  "111031000": ["100301", "A", "99.02.01"],
  "111032100": ["100501", "A", "01.05"],
  "111032200": ["100501", "A", "01.05"],
  "111032300": ["100501", "A", "01.05"],
  "111032900": ["100501", "A", "01.05"],
  "111033100": ["100301", "A", "99.02.01"],
  "111033200": ["100301", "A", "99.02.01"],
  "111033300": ["100501", "A", "03.02"],
  "111033400": ["100301", "A", "99.02.01"],
  "111033500": ["100301", "A", "99.02.01"],
  "111033610": ["100301", "A", "99.02.01"],
  "111033620": ["100301", "A", "99.02.01"],
  "111033690": ["100301", "A", "99.02.01"],
  "111033900": ["100301", "A", "99.02.01"],
  "111034100": ["100301", "A", "99.02.01"],
  "111034200": ["100301", "A", "99.02.01"],
  "111034300": ["100301", "A", "99.02.01"],
  "111035000": ["100301", "A", "99.02.01"],
  "111039000": ["100301", "A", "99.02.01"],
  "111041000": ["100301", "A", "99.02.01"],
  "111042000": ["100501", "A", "03.02"],
  "111043000": ["100301", "A", "99.02.01"],
  "111049000": ["100301", "A", "99.02.01"],
  "111051000": ["100301", "A", "99.02.01"],
  "111052000": ["100301", "A", "99.02.01"],
  "111053000": ["100301", "A", "99.02.01"],
  "111054100": ["100301", "A", "99.02.01"],
  "111054200": ["100301", "A", "99.02.01"],
  "111055100": ["100301", "A", "99.02.01"],
  "111055900": ["100301", "A", "99.02.01"],
  "111056000": ["100301", "A", "99.02.01"],
  "111057000": ["100301", "A", "99.02.01"],
  "111059000": ["100301", "A", "99.02.01"],
  "111061000": ["100301", "A", "99.02.01"],
  "111062000": ["100501", "A", "01.05"],
  "111063100": ["100301", "A", "99.02.01"],
  "111063200": ["100301", "A", "99.02.01"],
  "111063300": ["100501", "A", "03.02"],
  "111063400": ["100301", "A", "99.02.01"],
  "111063500": ["100301", "A", "99.02.01"],
  "111063610": ["100301", "A", "99.02.01"],
  "111063620": ["100301", "A", "99.02.01"],
  "111063690": ["100301", "A", "99.02.01"],
  "111063900": ["100301", "A", "99.02.01"],
  "111064100": ["100301", "A", "99.02.01"],
  "111064200": ["100301", "A", "99.02.01"],
  "111064300": ["100301", "A", "99.02.01"],
  "111065000": ["100301", "A", "99.02.01"],
  "111069000": ["100301", "A", "99.02.01"],
  "111071000": ["100301", "A", "99.02.01"],
  "111072000": ["100501", "A", "01.05"],
  "111073100": ["100301", "A", "99.02.01"],
  "111073200": ["100301", "A", "99.02.01"],
  "111073300": ["100501", "A", "03.02"],
  "111073900": ["100301", "A", "99.02.01"],
  "111074000": ["100301", "A", "99.02.01"],
  "111075000": ["100301", "A", "99.02.01"],
  "111079000": ["100301", "A", "99.02.01"],
  "111081000": ["100301", "A", "99.02.01"],
  "111082000": ["100501", "A", "03.02"],
  "111083000": ["100301", "A", "99.02.01"],
  "111089000": ["100301", "A", "99.02.01"],
  "111091000": ["100301", "A", "99.02.01"],
  "111092000": ["100301", "A", "99.02.01"],
  "111093000": ["100301", "A", "99.02.01"],
  "111099000": ["100301", "A", "99.02.01"],
  "111100000": ["100301", "A", "17.08"],
  "112011100": ["100301", "A", "02.01"],
  "112011200": ["100301", "A", "02.01"],
  "112011900": ["100301", "A", "02.01"],
  "112012000": ["100301", "A", "02.01"],
  "112013100": ["100301", "A", "02.01"],
  "112013200": ["100301", "A", "02.01"],
  "112013300": ["100301", "A", "02.01"],
  "112013400": ["100301", "A", "02.01"],
  "112013900": ["100301", "A", "02.01"],
  "112014000": ["100301", "A", "02.01"],
  "112015000": ["100301", "A", "02.01"],
  "112019000": ["100301", "A", "02.01"],
  "112021000": ["100301", "A", "02.01"],
  "112022000": ["100301", "A", "02.01"],
  "112023000": ["100301", "A", "02.01"],
  "112024000": ["100301", "A", "02.01"],
  "112029000": ["100301", "A", "02.01"],
  "112030000": ["100301", "A", "02.01"],
  "113011000": ["100301", "A", "17.14"],
  "113012000": ["100301", "A", "17.14"],
  "113013000": ["100301", "A", "17.01"],
  "113014000": ["100301", "A", "17.15"],
  "113019000": ["100301", "A", "17.14"],
  "113021100": ["100301", "A", "17.16"],
  "113021900": ["100301", "A", "17.16"],
  "113022100": ["100301", "A", "17.19"],
  "113022200": ["100301", "A", "17.19"],
  "113022300": ["100301", "A", "17.19"],
  "113031000": ["100301", "A", "17.14"],
  "113032000": ["100301", "A", "17.14"],
  "113040000": ["100301", "A", "21.01"],
  "114011100": ["100301", "A", "17.01"],
  "114011200": ["100301", "A", "17.20"],
  "114011300": ["100301", "A", "17.01"],
  "114011400": ["100301", "A", "17.01"],
  "114011500": ["100301", "A", "17.01"],
  "114011600": ["100301", "A", "17.01"],
  "114011700": ["100301", "A", "17.01"],
  "114011800": ["100301", "A", "17.01"],
  "114011900": ["100301", "A", "17.01"],
  "114012100": ["100301", "A", "17.12"],
  "114012200": ["100301", "A", "17.12"],
  "114012900": ["100301", "A", "17.03"],
  "114013100": ["100301", "A", "35.01"],
  "114013200": ["100301", "A", "35.01"],
  "114013900": ["100301", "A", "17.03"],
  "114021100": ["100301", "A", "07.03"],
  "114021200": ["100301", "A", "07.01"],
  "114021300": ["100301", "A", "07.01"],
  "114021400": ["100301", "A", "07.01"],
  "114021500": ["020201", "I", "07.19"],
  "114022100": ["100301", "A", "07.03"],
  "114022200": ["100301", "A", "07.03"],
  "114023100": ["100301", "A", "07.01"],
  "114023200": ["100301", "A", "07.01"],
  "114029000": ["100301", "A", "07.01"],
  "114031000": ["100301", "A", "07.03"],
  "114032110": ["020201", "I", "07.19"],
  "114032120": ["020201", "I", "07.19"],
  "114032211": ["100301", "A", "07.01"],
  "114032212": ["100301", "A", "07.01"],
  "114032213": ["100301", "A", "07.01"],
  "114032214": ["100301", "A", "07.01"],
  "114032221": ["100301", "A", "07.01"],
  "114032222": ["100301", "A", "07.01"],
  "114032223": ["100301", "A", "07.01"],
  "114032290": ["100301", "A", "07.01"],
  "114032300": ["100301", "A", "07.01"],
  "114032400": ["100301", "A", "07.01"],
  "114032500": ["100301", "A", "07.01"],
  "114032600": ["100301", "A", "07.01"],
  "114032700": ["100301", "A", "07.01"],
  "114032900": ["100301", "A", "07.01"],
  "114033000": ["020201", "I", "07.19"],
  "114039000": ["100301", "A", "07.01"],
  "114041100": ["100301", "A", "07.01"],
  "114041200": ["100301", "A", "07.01"],
  "114041300": ["100301", "A", "07.01"],
  "114041400": ["100301", "A", "28.01"],
  "114041900": ["020201", "I", "07.21"],
  "114042100": ["100301", "A", "07.20"],
  "114042200": ["100301", "A", "07.20"],
  "114043000": ["100301", "A", "36.01"],
  "114044100": ["100301", "A", "17.09"],
  "114044200": ["100301", "A", "17.09"],
  "114044300": ["100301", "A", "17.09"],
  "114044400": ["100301", "A", "17.09"],
  "114044900": ["100301", "A", "17.09"],
  "114051100": ["050101", "P", "05.02"],
  "114051200": ["050101", "P", "05.07"],
  "114052100": ["050101", "P", "05.02"],
  "114052200": ["050101", null, "05.07"],
  "114053000": ["100301", "A", "25.02"],
  "114054000": ["050101", "P", "05.06"],
  "114055000": ["100301", "A", "05.09"],
  "114056000": ["050101", "P", "05.08"],
  "114059000": ["050101", "P", "05.04"],
  "114061100": ["100301", "A", "17.06"],
  "114061200": ["100301", "A", "17.06"],
  "114061900": ["100301", "A", "17.06"],
  "114062000": ["100301", "A", "10.08"],
  "114063300": ["100101", "A", "17.25"],
  "114063400": ["100101", "A", "17.25"],
  "114063900": ["100101", "A", "17.25"],
  "114070000": ["100301", "A", "17.06"],
  "114081100": ["100301", "A", "13.03"],
  "114081200": ["100301", "A", "13.03"],
  "114081300": ["100301", "A", "13.03"],
  "114081400": ["100301", "A", "13.03"],
  "114081500": ["100301", "A", "13.03"],
  "114081900": ["100301", "A", "13.03"],
  "114082000": ["100301", "A", "13.03"],
  "114091100": ["020201", "I", "07.11"],
  "114091200": ["020201", "I", "07.11"],
  "114092100": ["100301", "A", "23.01"],
  "114092200": ["100301", "A", "23.01"],
  "114092300": ["100301", "A", "23.01"],
  "114092400": ["100301", "A", "23.01"],
  "114092500": ["100301", "A", "23.01"],
  "114092900": ["100301", "A", "23.01"],
  "114093000": ["100301", "A", "23.01"],
  "114099000": ["100301", "A", "32.01"],
  "114101000": ["100301", "A", "17.01"],
  "114109000": ["100301", "A", "17.01"],
  "114110000": ["100301", "A", "17.02"],
  "114120000": ["100301", "A", "17.01"],
  "114130000": ["100301", "A", "17.01"],
  "114140000": ["100301", "A", "17.01"],
  "114150000": ["100301", "A", "31.01"],
  "115011000": ["100301", "A", "01.06"],
  "115012000": ["100301", "A", "01.06"],
  "115013000": ["050101", "P", "01.07"],
  "115021000": ["100301", "A", "01.07"],
  "115022000": ["100301", "A", "01.07"],
  "115023000": ["100301", "A", "01.08"],
  "115024000": ["100301", "A", "01.01"],
  "115025000": ["100301", "A", "01.01"],
  "115029000": ["100301", "A", "01.04"],
  "115030000": ["100301", "A", "01.01"],
  "115040000": ["100301", "A", "01.01"],
  "115050000": ["100301", "A", "01.01"],
  "115061000": ["100301", "A", "01.03"],
  "115062100": ["100501", "A", "01.05"],
  "115062200": ["100301", "A", "01.03"],
  "115062300": ["100301", "A", "01.03"],
  "115062900": ["100301", "A", "01.03"],
  "115069000": ["100301", "A", "01.03"],
  "115071000": ["100301", "A", "01.06"],
  "115072000": ["100301", "A", "01.06"],
  "115079000": ["100301", "A", "01.06"],
  "115080000": ["100301", "A", "01.07"],
  "115090000": ["100301", "A", "01.03"],
  "115100000": ["100301", "A", "01.06"],
  "117031000": ["100301", "A", "01.09"],
  "117032100": ["100301", "A", "01.09"],
  "117032200": ["100301", "A", "01.09"],
  "117033100": ["100301", "A", "01.09"],
  "117033200": ["100301", "A", "01.09"],
  "117039100": ["100301", "A", "01.09"],
  "117039200": ["100301", "A", "01.09"],
  "117039900": ["100301", "A", "01.09"],
  "117041000": ["100301", "A", "35.01"],
  "117042000": ["100301", "A", "35.01"],
  "117051000": ["030101", "P", "29.01"],
  "117052000": ["100301", "A", "29.01"],
  "118011100": ["100301", "A", "17.04"],
  "118011200": ["100301", "A", "17.04"],
  "118012100": ["100301", "A", "17.05"],
  "118012200": ["100301", "A", "17.05"],
  "118012900": ["100301", "A", "17.05"],
  "118021000": ["100301", "A", "34.01"],
  "118022000": ["100301", "A", "11.02"],
  "118023000": ["100301", "A", "11.05"],
  "118024000": ["070101", "P", "26.01"],
  "118025000": ["030101", "P", "11.03"],
  "118029000": ["100301", "A", "11.02"],
  "118031000": ["020201", "I", "07.10"],
  "118032100": ["020201", "I", "07.13"],
  "118032200": ["020201", "I", "07.10"],
  "118032900": ["050101", null, "14.01"],
  "118040000": ["050101", "P", "14.05"],
  "118051100": ["100301", "A", "09.02"],
  "118051200": ["100301", "A", "09.02"],
  "118051300": ["100301", "A", "09.02"],
  "118051400": ["100301", "A", "09.02"],
  "118051900": ["100301", "A", "09.02"],
  "118052100": ["100301", "A", "09.02"],
  "118052200": ["100301", "A", "09.02"],
  "118052300": ["100301", "A", "09.02"],
  "118052400": ["100301", "A", "09.02"],
  "118053100": ["100301", "A", "09.02"],
  "118053200": ["100301", "A", "09.02"],
  "118053900": ["100301", "A", "09.02"],
  "118054000": ["100301", "A", "09.02"],
  "118055000": ["030101", "P", "09.03"],
  "118056100": ["100301", "A", "09.02"],
  "118056200": ["100301", "A", "09.02"],
  "118061000": ["100301", "A", "17.01"],
  "118062000": ["100301", "A", "17.22"],
  "118063100": ["100301", "A", "17.02"],
  "118063900": ["100301", "A", "17.02"],
  "118064000": ["100301", "A", "17.02"],
  "118065100": ["100301", "A", "13.04"],
  "118065200": ["100301", "A", "17.02"],
  "118065300": ["100301", "A", "17.02"],
  "118065900": ["100301", "A", "17.02"],
  "118066100": ["040101", "V", "17.10"],
  "118066200": ["040101", "V", "17.10"],
  "118066300": ["100301", "A", "17.11"],
  "118067000": ["020201", "I", "07.11"],
  "118068100": ["100301", "A", "37.01"],
  "118068200": ["100301", "A", "37.01"],
  "118068300": ["100301", "A", "37.01"],
  "118069000": ["100301", "A", "17.17"],
  "119011000": ["100301", "A", "07.22"],
  "119013000": ["020201", "I", "07.16"],
  "119021000": ["020201", "I", "07.21"],
  "119029000": ["020201", "I", "07.21"],
  "120011000": ["050101", "P", "14.02"],
  "120012000": ["050101", null, "14.02"],
  "120013110": ["050101", "P", "14.12"],
  "120013120": ["050101", null, "14.02"],
  "120013200": ["050101", null, "14.02"],
  "120013300": ["050101", null, "14.02"],
  "120013410": ["050101", null, "14.02"],
  "120013420": ["050101", null, "14.02"],
  "120013430": ["050101", null, "14.02"],
  "120013500": ["050101", null, "14.02"],
  "120013900": ["050101", null, "14.02"],
  "120014000": ["050101", null, "14.02"],
  "120015000": ["050101", null, "14.02"],
  "120016000": ["050101", null, "14.02"],
  "120017000": ["050101", null, "14.02"],
  "120018100": ["050101", null, "14.02"],
  "120018200": ["050101", null, "14.02"],
  "120018300": ["050101", null, "14.02"],
  "120018900": ["050101", "P", "15.03"],
  "120021000": ["050101", null, "14.02"],
  "120022000": ["050101", "P", "39.01"],
  "120023000": ["050101", null, "14.02"],
  "120024000": ["050101", "P", "14.11"],
  "120029000": ["050101", null, "14.05"],
  "120031000": ["050101", null, "14.06"],
  "120032110": ["050101", null, "14.06"],
  "120032190": ["050101", null, "14.06"],
  "120032200": ["050101", null, "14.06"],
  "120032300": ["050101", null, "14.06"],
  "120032400": ["050101", null, "14.06"],
  "120032510": ["050101", null, "14.06"],
  "120032520": ["050101", null, "14.06"],
  "120032610": ["050101", null, "14.06"],
  "120032690": ["050101", null, "14.06"],
  "120032900": ["050101", null, "14.06"],
  "121011000": ["100301", "A", "13.05"],
  "121012100": ["100301", "A", "13.05"],
  "121012200": ["050101", "P", "14.08"],
  "121012300": ["100301", "A", "13.03"],
  "122011100": ["030101", "P", "08.01"],
  "122011200": ["030101", null, "08.01"],
  "122011900": ["030101", null, "08.01"],
  "122012000": ["030101", null, "08.01"],
  "122013000": ["030101", null, "08.01"],
  "122020000": ["030101", "P", "08.01"],
  "122031000": ["030101", "P", "08.01"],
  "122032000": ["030101", "P", "08.01"],
  "122041000": ["030101", "P", "08.01"],
  "122042000": ["030101", "P", "08.01"],
  "122043000": ["030101", "P", "08.01"],
  "122044000": ["030101", "P", "08.01"],
  "122051100": ["030101", "P", "08.02"],
  "122051200": ["030101", "P", "06.04"],
  "122051300": ["030101", "P", "08.02"],
  "122051400": ["030101", "P", "17.24"],
  "122051900": ["030101", "P", "08.02"],
  "122052000": ["030101", "P", "08.02"],
  "123011100": ["030101", "P", "04.04"],
  "123011200": ["030101", "P", "04.11"],
  "123011300": ["030101", null, "04.03"],
  "123011400": ["030101", null, "04.03"],
  "123011500": ["030101", null, "04.03"],
  "123011900": ["030101", null, "04.03"],
  "123012100": ["030101", "P", "04.18"],
  "123012200": ["030101", "P", "04.01"],
  "123012300": ["030101", "P", "04.12"],
  "123019100": ["030101", "P", "04.06"],
  "123019200": ["030101", "P", "04.08"],
  "123019300": ["030101", null, "04.03"],
  "123019400": ["030101", "P", "04.02"],
  "123019500": ["030101", "P", "04.20"],
  "123019600": ["030101", "P", "04.21"],
  "123019700": ["030101", null, "04.11"],
  "123019800": ["030101", "P", "04.16"],
  "123019900": ["030101", "P", "04.15"],
  "123021000": ["030101", "P", "04.17"],
  "123022100": ["030101", "P", "04.17"],
  "123022200": ["030101", "P", "04.17"],
  "123022300": ["030101", "P", "04.17"],
  "123030000": ["030101", "P", "04.17"],
  "123041100": ["030101", "P", "27.01"],
  "123041200": ["030101", null, "27.01"],
  "123041900": ["030101", null, "27.01"],
  "123042000": ["030101", null, "27.01"],
  "123049000": ["100301", "A", "27.01"],
  "124022000": ["020201", "I", "07.09"],
  "124031100": ["050101", "P", "07.09"],
  "124031200": ["050101", null, "07.09"],
  "124031900": ["050101", null, "07.09"],
  "124032100": ["050101", null, "07.09"],
  "124032200": ["050101", null, "07.09"],
  "124033100": ["050101", null, "07.09"],
  "124033200": ["050101", null, "07.09"],
  "124041100": ["050101", null, "07.09"],
  "124041200": ["050101", null, "07.09"],
  "124041300": ["050101", null, "07.09"],
  "124041900": ["050101", null, "07.09"],
  "124042100": ["050101", null, "07.09"],
  "124042200": ["050101", null, "07.09"],
  "124043100": ["050101", null, "07.09"],
  "124043200": ["050101", null, "07.09"],
  "124043300": ["050101", null, "07.09"],
  "124043900": ["050101", null, "07.09"],
  "124051100": ["100301", "A", "07.12"],
  "124051200": ["100301", "A", "07.12"],
  "124051300": ["100301", "A", "07.12"],
  "124051400": ["020201", "I", "07.10"],
  "124052000": ["100301", "A", "07.12"],
  "124059000": ["100301", "A", "07.12"],
  "124061000": ["020201", "I", "07.09"],
  "124069000": ["020201", "I", "07.18"],
  "124070000": ["020201", "I", "07.10"],
  "125011100": ["100301", "A", "13.02"],
  "125011200": ["100301", "A", "13.02"],
  "125012100": ["040101", "V", "12.13"],
  "125012200": ["040101", "V", "12.13"],
  "125013100": ["100301", "A", "13.03"],
  "125013200": ["100301", "A", "13.03"],
  "125013300": ["100301", "A", "13.03"],
  "125013400": ["100301", "A", "13.03"],
  "125013500": ["100301", "A", "13.03"],
  "125013600": ["100301", "A", "13.03"],
  "125013700": ["100301", "A", "13.02"],
  "125013900": ["100301", "A", "13.03"],
  "125014000": ["100301", "A", "10.03"],
  "125015000": ["100301", "A", "12.16"],
  "125019000": ["100301", "A", "13.03"],
  "125021000": ["040101", "V", "12.13"],
  "125022000": ["040101", "V", "12.15"],
  "125023000": ["040101", "V", "12.13"],
  "125029000": ["100301", "A", "12.16"],
  "125031000": ["100301", "A", "37.01"],
  "125032000": ["100301", "A", "40.01"],
  "125041100": ["030101", "P", "38.01"],
  "125041200": ["030101", "P", "38.01"],
  "125042100": ["030101", "P", "12.05"],
  "125042200": ["030101", "P", "12.05"],
  "125051000": ["100301", "A", "12.16"],
  "125052000": ["030101", "P", "12.11"],
  "125059000": ["030101", null, "12.11"],
  "125060000": ["100301", "A", "37.01"],
  "125071000": ["030101", "P", "12.05"],
  "125079000": ["030101", "P", "12.05"],
  "125080000": ["030101", "P", "12.17"],
  "126011000": ["050101", "P", "14.10"],
  "126012000": ["050101", null, "14.10"],
  "126013000": ["050101", null, "14.10"],
  "126014000": ["050101", null, "14.10"],
  "126019000": ["050101", null, "14.10"],
  "126021000": ["030101", "P", "06.01"],
  "126022000": ["030101", "P", "06.02"],
  "126023000": ["030101", "P", "06.05"],
  "126029000": ["030101", "P", "06.06"],
  "126030000": ["020101", "I", "25.05"],
  "126040000": ["050101", "P", "14.09"],
  "126060000": ["100301", "A", "33.01"],
};

/** Devolve { indop, local, localNome, lc116 } ou null se a NBS não estiver na tabela. */
export function incidenciaDaNbs(nbs) {
  const cod = String(nbs || "").replace(/\D/g, "");
  const e = NBS_INCIDENCIA[cod];
  if (!e) return null;
  return { indop: e[0], local: e[1], localNome: e[1] ? LOCAL_INCIDENCIA[e[1]] : null, lc116: e[2] };
}
